import Alert from "../../helpers/alert";

export function copyInviteLink(url) {
  if (!url) {
    Alert.toastError("Link do convite indisponível.");
    return;
  }

  navigator.clipboard.writeText(url).then(() => {
    Alert.toastSuccess("Link copiado.");
  }).catch(() => {
    Alert.toastError("Não foi possível copiar o link.");
  });
}
